import { Box, Typography } from '@mui/material'
import React from 'react'

type TextPairProps = {
  icon?: React.ReactNode
  label: React.ReactNode
  value: React.ReactNode
  justifyBetween?: boolean
  separator?: string
  flexDirection?: 'row' | 'column'
}

export const TextPair = ({
  flexDirection = 'row',
  icon,
  justifyBetween = true,
  label,
  separator = ':',
  value,
}: TextPairProps) => {
  return (
    <Box
      sx={{
        ...(justifyBetween ? { display: 'flex', justifyContent: 'space-between' } : undefined),
        flexDirection,
      }}
    >
      <Typography
        component={'span'}
        sx={{
          alignItems: 'center',
          display: 'inline-flex',
          gap: 0.5,
          lineHeight: 'normal',
          whiteSpace: 'normal',
        }}
      >
        {icon}
        <span>{`${label}${separator}`}</span>
      </Typography>
      <Typography
        component={'span'}
        sx={{
          fontWeight: ['string', 'number'].includes(typeof value) ? 500 : undefined,
          ml: flexDirection === 'row' ? 0.5 : undefined,
        }}
      >
        {value}
      </Typography>
    </Box>
  )
}
